import {
  Link,
  LinkProps,
  Navigate,
  NavigateProps,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { searchParamsToState } from "../../utils/querystring";
import { getToParam } from "../hooks/useNavigateWithSearchState";
import { ForwardedRef, forwardRef } from "react";

export const SearchStateLink = forwardRef(
  (props: LinkProps, ref: ForwardedRef<HTMLAnchorElement>) => {
    const location = useLocation();
    const [search] = useSearchParams();
    return (
      <Link
        ref={ref}
        {...props}
        to={getToParam(props.to, location)}
        state={{ ...props.state, previousSearch: searchParamsToState(search) }}
      />
    );
  },
);

SearchStateLink.displayName = "SearchStateLink";

export const SearchStateNavigate = (props: NavigateProps) => {
  const location = useLocation();
  const [search] = useSearchParams();

  return (
    <Navigate
      {...props}
      to={getToParam(props.to, location)}
      state={{ ...props.state, previousSearch: searchParamsToState(search) }}
    />
  );
};
